import React from 'react';
import { FaBoxOpen } from 'react-icons/fa'; // You need to install react-icons package
 
const EmptyOrderPage = () => {
  return (
    <div className="flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-sm text-center">
        <FaBoxOpen className="text-6xl text-gray-400 mb-4 mx-auto" />
        <h1 className="text-2xl font-bold text-gray-800 mb-2">No Previous Orders</h1>
        <p className="text-gray-600 mb-6">You haven't placed any orders yet. Browse our products and start shopping!</p>
        <button
          onClick={() => window.history.back()}
          className="bg-[#DC0A0A] text-white px-6 py-2 rounded-full hover:bg-[#DC0A0A] transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#DC0A0A] focus:ring-opacity-75"
        >
          Go Back
        </button>
      </div>
    </div>
  );
};
 
export default EmptyOrderPage;